const discrepancy = {
  discrepancy_configuration: "Configuración De Discrepancia",
  discrepancy: "Discrepancia",
  predefined_erp: "Predefinido ERP",
  matching_documents: "Documentos coincidentes",
  total: "Total",
  connected_documents: "Documentos conectados",
  external_systems: "Sistemas externos",
  header_fields: "Campos de Cabecera",
  line_items: "Artículos de Línea",
  total_amount: "Monto Total",
  total_without_tax: "Total sin Impuesto",
  total_tax: "Impuesto Total",
};
export default discrepancy;
